export default __webpack_public_path__ + "static/media/paige_adams.edd33686.png";